import { Col, Row, Spinner, Tab, Tabs } from "react-bootstrap"

import { useEffect, useState } from "react";
import { Container, CustomRow, HeaderRow } from "./styles";
import { Checkbox } from "primereact/checkbox";

import { BsArrowDownUp } from "react-icons/bs";
import { ISettingsCategoryService, mediaCategory, updateMediaCategory } from "../../../../../services/manager-settings.service";
import { PrimaryButton } from "../../../styled";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../../../components/modal";
import { InputNumber } from "antd";
import { currencyParser } from "../../../../../utils/currencyParser";
import { InputSwitch } from "primereact/inputswitch";
import { ICommonTestComponent } from "../../../../../models/ICommonTestComponent";

export interface ISettingsCategories {
    id: number;
    category: number;
    category_icon: string;
    category_name: string;
    is_active: boolean;
    price?: number;
}

export const Pricing: React.FC<ICommonTestComponent> = ({ jestFunc = () => {}, testMode = false}) => {
    const { t: translation } = useTranslation();

    const [key, setKey] = useState<string>("price");
    const [loading, setLoading] = useState<boolean>(false);

    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)
    const [isModalLoading, setIsModalLoading] = useState<boolean>(false)

    const [categories, setCategories] = useState<ISettingsCategories[]>([])
    const [oldCategories, setOldCategories] = useState<ISettingsCategories[]>([])

    const [isBasePrice, setIsBasePrice] = useState<boolean>(false)
    const [hasUpdate, setHasUpdate] = useState<boolean>(false)

    const [isOrderedByName, setIsOrderedByName] = useState<boolean>(false)
    const [isOrderedByPrice, setIsOrderedByPrice] = useState<boolean>(false)


    useEffect(() => {
        setLoading(true)
        mediaCategory().then((data) => {
            setCategories(data.categories);
            setOldCategories(JSON.parse(JSON.stringify(data.categories)))
            setLoading(false)
        })
    }, [])

    useEffect(() => {

        const categoriesInfo = countSelectableCategories(categories)

        if (categoriesInfo.selectable === categoriesInfo.selected) {
            setIsBasePrice(true)
        } else {
            setIsBasePrice(false)
        }
    }, [categories])

    const countSelectableCategories = (_categories: ISettingsCategories[]) => {
        let selectable = 0
        let selected = 0
        _categories.forEach(category => {
            if (!!category.price) {
                selectable += 1
            }
            if (category.is_active) {
                selected += 1
            }
        })
        return {
            selectable,
            selected,
        }
    }

    const checkAll = (insideCheck: boolean) => {

        let mirrorCategories = categories

        if (insideCheck) {
            mirrorCategories.forEach(category => {
                if (!!category.price) {
                    category.is_active = true
                }
            })
        } else {
            mirrorCategories.forEach(category => {
                if (!!category.price) {
                    category.is_active = false
                }
            })
        }


        setCategories([...mirrorCategories])
        setHasUpdate(true)

    }

    const compare = (a: any, b: any) => {
        if (!isOrderedByName) {
            setIsOrderedByName(true)
            if (a.category_name < b.category_name) {
                return 1;
            }
            if (a.category_name > b.category_name) {
                return -1;
            }
        } else {
            setIsOrderedByName(false)
            if (a.category_name < b.category_name) {
                return -1;
            }
            if (a.category_name > b.category_name) {
                return 1;
            }
        }

        return 0;
    }

    const sortList = (column: string) => {
        let mirrorCategories = categories
        if (column === 'name') {
            mirrorCategories.sort(compare)

        } else {

            if (!isOrderedByPrice) {
                setIsOrderedByPrice(true)

                mirrorCategories.sort((a, b) => {
                    return (b.price || 0) - (a.price || 0)
                });

            } else {
                setIsOrderedByPrice(false)

                mirrorCategories.sort((a, b) => {
                    return (a.price || 0) - (b.price || 0)
                });
            }

        }

        setCategories([...mirrorCategories])


    }

    const handleChangeTab = (k: string) => {
        setKey(k);

        // switch (k) {
        //     case 'price':
        //         console.log('price');
        //         break;

        //     default:
        //         break
        // }
    }

    const handleChangeCategory = (value: any, field: string, index: number) => {

        let update = false


        let mirrorCategories = categories
        let mirrorOldCategories = oldCategories


        switch (field) {
            case 'baseActive':
                setIsBasePrice(value)
                update = true
                break
            case 'price':

                mirrorCategories[index].price = value

                if ((mirrorOldCategories[index].price !== mirrorCategories[index].price)) {
                    update = true
                }

                // Deactivate case no price
                if (!mirrorCategories[index].price) {
                    mirrorCategories[index].is_active = false
                }


                break;
            case 'is_active':
                mirrorCategories[index].is_active = value

                if (mirrorCategories[index].is_active !== mirrorOldCategories[index].is_active) {
                    update = true
                }

                break;
            default:
                break;
        }

        setCategories([...mirrorCategories])
        setOldCategories(oldCategories)
        setHasUpdate(update)
    }

    const handleUpdateCategory = () => {

        let req: ISettingsCategoryService = {
            categories: categories,
            is_base_price: isBasePrice
        }
        setLoading(true)
        setIsModalLoading(true)
        updateMediaCategory(req).then((data) => {
            setCategories(data.categories);
            setOldCategories(JSON.parse(JSON.stringify(data.categories)))
            setIsBasePrice(data.is_base_price)
            setIsModalLoading(false)
            setLoading(false)
            setShowConfirmModal(false)
            setHasUpdate(false)
        })

    }

    return (
        <Container className="ml-2 mt-3 mr-4">
            <div id="tabs-materials">
                <Row>
                    <Col xxl={9} lg={8}>
                        <h5 className="text-black mb-4"><b>{translation('manager.settings.setPricing')}</b></h5>
                    </Col>
                    {(hasUpdate || testMode) && (
                        <Col xxl={3} lg={4}>
                            <PrimaryButton style={{ width: '100%', float: 'right' }}>
                                <button type="button" data-testid="buttonToOpenModal" onClick={() => {setShowConfirmModal(true); jestFunc('openModal')}}>
                                    {translation('manager.saveChanges')}
                                </button>
                            </PrimaryButton>
                        </Col>
                    )}



                </Row>
                <Tabs className="tabs mb-3" activeKey={key} onSelect={(k: any) => handleChangeTab(k)}>
                    <Tab eventKey="price" style={{ fontWeight: 400 }} title={translation('manager.settings.prices')}>
                        {
                            !!loading && !testMode ? (
                                <div className="loading-container mt-5">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : (
                                <>
                                    <Row>
                                        <Col md={12} className="mt-3">
                                            <p style={{ fontSize: 14, color: '#333333', fontWeight: 300, }}>{translation('manager.settings.pricingDefinition')}</p>
                                        </Col>
                                        <Col xxl={12}>
                                            <Row className="justify-content-md-end">
                                                {isBasePrice ? (
                                                    <Col xxl={4} lg={6} xs={10}>
                                                        <p className="text-end text-darker-grey" style={{ fontSize: 14, fontWeight: 400 }}>{translation('manager.settings.pricingDisCheckAll')}</p>
                                                    </Col>
                                                ) : (
                                                    <Col xxl={4} lg={6} xs={10}>
                                                        <p className="text-end text-darker-grey" style={{ fontSize: 14, fontWeight: 400 }}>{translation('manager.settings.pricingCheckAll')}</p>
                                                    </Col>
                                                )}

                                                {!!countSelectableCategories(categories).selectable ? (
                                                    <Col xxl={1} lg={1} xs={2}>
                                                        <InputSwitch disabled={false} checked={isBasePrice} onChange={(e: any) => checkAll(e.value)} />
                                                    </Col>
                                                ) : (
                                                    <Col xxl={1} lg={1} xs={2}>
                                                        <InputSwitch checked={false} />
                                                    </Col>
                                                )}

                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 mt-3">
                                        <HeaderRow className="ml-2">
                                            <Col xxl={8} lg={6}>
                                                <span>  {translation('manager.settings.name')} <BsArrowDownUp size={10} onClick={() => sortList('name')} style={{ cursor: 'pointer' }} /></span>
                                            </Col>
                                            <Col xxl={2} lg={3}>
                                                <span style={{ textAlign: 'left' }}> {translation('manager.settings.basePrice')} <BsArrowDownUp size={10} onClick={() => sortList('price')} style={{ cursor: 'pointer' }} /></span>
                                            </Col>
                                            <Col xxl={2} lg={3}>
                                                <span style={{ justifyContent: 'center' }}>{translation('manager.settings.applyBasePrice')}</span>
                                            </Col>
                                        </HeaderRow>
                                        {categories.length && categories.map((category, index: number) => (
                                            <CustomRow key={category.id} className="ml-2">
                                                <Col style={{ display: 'flex', alignItems: 'center', gap: 10 }} xxl={8} lg={6}>

                                                    <em style={{ color: '#606060' }} className={`material-icons-${category.category_icon}`}>{category.category_icon.split(' ')[1]}</em>
                                                    <span>{category.category_name}</span>

                                                </Col>

                                                <Col xxl={2} lg={3}>
                                                    {!!category.price ? (
                                                        <InputNumber
                                                            defaultValue={category.price}
                                                            style={{
                                                                width: 150,
                                                                marginRight: "1rem",
                                                                color: "#606060",
                                                                fontSize: 16
                                                            }}
                                                            formatter={(value: any) => Intl.NumberFormat('pt-br', {
                                                                style: "currency",
                                                                currency: 'BRL'
                                                            }).format(value)}
                                                            parser={currencyParser}
                                                            bordered={false}
                                                            onChange={(e: any) => handleChangeCategory(e, 'price', index)}
                                                            min={0} max={999999}
                                                            placeholder="Digite o preço"
                                                        />
                                                    ) : (
                                                        <InputNumber
                                                            defaultValue={category.price}
                                                            style={{
                                                                width: 150,
                                                                marginRight: "1rem",
                                                                color: "#A5A5A5",
                                                                fontSize: 16
                                                            }}
                                                            formatter={(value: any) => Intl.NumberFormat('pt-br', {
                                                                style: "currency",
                                                                currency: 'BRL'
                                                            }).format(value)}
                                                            parser={currencyParser}
                                                            bordered={false}
                                                            onChange={(e: any) => handleChangeCategory(e, 'price', index)}
                                                            min={0} max={999999}
                                                            placeholder="Digite o preço"
                                                        />
                                                    )}

                                                </Col>

                                                <Col xxl={2} lg={3} style={{ textAlign: 'center' }}>
                                                    <Checkbox checked={category.is_active} disabled={!category.price} onChange={(e) => { handleChangeCategory(e.checked, 'is_active', index) }} />
                                                </Col>
                                            </CustomRow>
                                        ))}

                                    </Row>
                                </>
                            )
                        }
                    </Tab>
                </Tabs>
            </div>
            <Modal
                headerTitle="Aviso"
                submitButtonText={translation('manager.user.confirm')}
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onSubmit={handleUpdateCategory}
                variant="confirm-modal-default"
                loading={isModalLoading}
            >
                <p>
                    Os materiais que já estão publicados permanecerão com o preço que foi aplicado.
                </p>
            </Modal>

        </Container>

    )
}